export enum SystemConfigDocumentId {
  POSTMARK_BULK = 'postmarkBulk',
  SENDGRID_BULK = 'sendgridBulk',
  HARD_COUPLE_SPLIT_REGISTRATION = 'hardCoupleSplitRegistration',
  /** COU-337 — upload email images to the CDN instead of embedding them as base64. */
  MAILING_CDN_IMAGES = 'mailingCdnImages'
}
